/* eslint-disable react-hooks/rules-of-hooks */

import { useSessionStorage } from 'hooks/useSessionStorage';
import jwt_decode from 'jwt-decode';
import { Company } from 'types';

type tokenType = {
	role: string;
	master: string;
	permissions: string[];
};

const getToken = () => {
	const { getSessionStorage } = useSessionStorage();
	return getSessionStorage('idToken');
};

export const getMe = () => {
	const { getSessionStorage } = useSessionStorage();
	const data = getSessionStorage('me');
	return data ? JSON.parse(data) : undefined;
};

export const decodeToken = () => {
	const token = getToken();
	if (token) {
		return jwt_decode<tokenType>(token);
	}
	return '';
};

export const checkFunctionalityPermission = (
	functionality: string,
): boolean => {
	const decodedToken = decodeToken();
	if (decodedToken) {
		if (decodedToken?.master === 'true') return true;
		if (decodedToken?.permissions?.includes(functionality)) return true;

		return false;
	}
	return false;
};

export const checkHRAPermission = (): boolean => {
	const meData = getMe();
	return Boolean(meData?.company?.companyPortalSettings?.hasHra);
};

export const verifyIsCompanyPermited = (
	company: Company,
	permissionId: string,
) => {
	return (
		company.companyPermissions &&
		company.companyPermissions.some((permission: { id: string }) => {
			return permission.id === permissionId;
		})
	);
};
